import * as React from 'react';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core';

import { withIntl, IntlProps } from 'ha/i18n';
import formatDateRange from 'ha/helpers/hadate/formatDateRange';
import Button, { ButtonProps } from 'ha/ui/next/Button';
import SvgIcon from 'ha/ui/next/SvgIcon';
import CalendarIcon from 'streamline-icons/calendar.svg';
import Hidden from 'ha/ui/next/Hidden';
import Grid from 'ha/ui/next/Grid';

const styles = (theme: Theme) =>
  createStyles({
    calendarIcon: {
      stroke: theme.palette.primary.main,
      height: '1rem',
      width: '1rem',
      marginRight: '0.5rem',
    },
  });

interface Props {
  startDate?: string;
  endDate?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  dataTestLocator?: string;
  size?: ButtonProps['size'];
}

export const DateFilterButton: React.SFC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({
  startDate,
  endDate,
  onClick,
  intl: { T, locale },
  dataTestLocator = 'Date Filter Button',
  classes,
  size,
}) => {
  const isActive = Boolean(startDate);

  return (
    <Button
      variant={isActive ? 'contained' : 'outlined'}
      color="primary"
      size={size}
      onClick={onClick}
      data-test-locator={dataTestLocator}
    >
      <Grid container alignItems="center">
        <Hidden mdUp>
          <SvgIcon className={classes.calendarIcon}>
            <CalendarIcon />
          </SvgIcon>
        </Hidden>
        {isActive && !Boolean(endDate) && `${T('From')} `}
        {isActive && formatDateRange(locale, startDate, endDate)}
        {!isActive && T('Dates')}
      </Grid>
    </Button>
  );
};

export default withIntl(withStyles(styles)(DateFilterButton));
